// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1OiuD","loaderOuter":"PageOverlayLoader_loaderOuter__2Z6mX"};